// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";
// import App from "./App";
// import { ThemeProvider } from "@mui/material/styles";
// import theme from "./theme";
// import { LicenseManager } from "ag-grid-enterprise";

// const LICENSE_KEY =
// 	"Using_this_AG_Grid_Enterprise_key_( AG-044837 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Impact Analytics )_is_granted_a_( Multiple Applications )_Developer_License_for_( 1 ))_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 9 July 2024 )____[v2]_MTcyMDQ3OTYwMDAwMA==f609b53bdf2c83442d9201c194909314";
// LicenseManager.setLicenseKey(LICENSE_KEY);

// ReactDOM.render(
// 	<ThemeProvider theme={theme}>
// 		<App />
// 	</ThemeProvider>,
// 	document.getElementById("root")
// );

import("./bootstrap");
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
